import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './image-index.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ImageIndex = props => ___EmotionJSX("div", {
  css: styles.container
}, ___EmotionJSX("div", {
  css: styles.text
}, props.currentSlide + 1, " / ", props.slideCount));
ImageIndex.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired
};
export default ImageIndex;